import React, { Component } from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import { Link, Redirect } from "react-router-dom";
import $ from "jquery";
import '../css/ipos-navbar.css';
import '../css/TotalEMI.css';
import DownArrow from '../../assets/img/welcomepage/down-arrow.png';
import BellIcon from '../../assets/img/welcomepage/TopbarIcons/bell.png';
import BackArrow from '../../assets/img/welcomepage/TopbarIcons/back-arrow.png';
import { Modal, ModalBody } from "react-responsive-modal";
import { Button } from 'react-bootstrap';



const closeIcon = (
    <svg fill="currentColor" viewBox="0 0 20 20" width={28} height={28}>
      <path
        fillRule="evenodd"
        d=""
        clipRule="evenodd"
      ></path>
    </svg>
  )
    
class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiMenus: [],
            TermModal: false,
            selectedradio:'All Terminals',
         };
}
componentDidMount(){

}


homepage = () => {
    return <Redirect to="/admin/welcomepage" />
}
callchild() {
    this.setState({ TermModal: true })
    // this.props.callbackFromParent("All terminal");
}

onCloseModal = () => {
    this.setState({
        TermModal: false,

    })
}


applyterminsl = () => {
    this.setState({
        TermModal: false
    })
    // alert(this.state.selectedradio)
    this.props.callbackFromParent(this.state.selectedradio);
}
checkterminal = (e) => {
    let currter=e.target.title;
    this.setState({selectedradio:currter})
  };

render() {
    return (
        <div className="content">
            <Modal
                open={this.state.TermModal}
                onClose={this.onCloseModal}
                classNames={{
                    overlay: "customOverlay",
                    modal: "customModal",
                }}
                closeIcon={closeIcon}
                center
            >
                <h4 style={{ color: '#F47626', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid', paddingBottom: '10px' }}>Select Terminal</h4>
                <div style={{ padding: '0px 60px' }}>
                    <div onClick={this.checkterminal}>
                        <input type="radio" checked={this.state.selectedradio.includes("All") ? true : false} title="All terminals" />
                        <h5 style={{ display: 'inline-block', paddingLeft: '10px' }} title="All terminals">All terminals</h5>
                        <br />
                    </div>
                    {this.props.allterminals.map((val,key) => {
                        return (
                            <div onClick={this.checkterminal}>
                                <input type="radio" checked={this.state.selectedradio === val} title={val}/>
                                <h5 style={{ display: 'inline-block', paddingLeft: '10px' }} title={val}> {val} (Terminal {key + 1})</h5>
                                <br />
                            </div>
                        )
                    })
                    }

                </div>
                <div className="text-center p-5">
                    <Button
                        style={{
                            background: "#ef7731",
                            color: "#fff",
                            borderRadius: "10px",
                            width: "100px",
                            margin: "5px",
                        }}
                        onClick={this.onCloseModal}
                        align="center"
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{
                            background: "#ef7731",
                            color: "#fff",
                            borderRadius: "10px",
                            width: "100px",
                            margin: "5px",
                        }}
                        onClick={() => { this.applyterminsl() }}
                        align="center"
                    >
                        Apply
                    </Button>
                </div>


            </Modal>

            <div className="container-fluid" >
                <div className="row">
                    <div className="rectangle">
                        <p className="all-terminals" style={{ lineHeight: '30px' }}>
                            <Link to="/admin/totalemi-dashboard"><img src={BackArrow} style={{ float: 'left', height: '30px' }} /></Link>

                            <span style={{ marginRight: '35px' }} onClick={() => { this.callchild() }}>{this.props.selectedterminals} <img src={DownArrow} style={{ marginLeft: '3px', marginTop: '-3px' }} /></span>

                        </p>
                    </div>

                </div>
            </div>
        </div>

    );

}


}
export default Navbar;